import { useState } from 'react'

// Firebase utilities
import { db } from '../../../../utils/firebase'

// UI components
import Input from '../../../ui/inputs/input'

// Returns the markup for the _dev tab when editing a holiday
export default function HolidayDev({ holidayID, holiday }) {
    const [hotelID, setHotelID] = useState(holiday?.bs2_id_hotel || '')
    const [altHotelIDs, setAltHotelIDs] = useState(holiday?.bs2_id_hotel_alternates || '')

    // On input focus blur, save the new hotel ID into the document
    const saveHotelID = async () => {
        console.log("Saving...")

        let altIDs = []

        if (typeof altHotelIDs === "string" && altHotelIDs.length > 0) {
            altIDs = altHotelIDs.split(",")
        }

        await db.doc(`CMS_holidays/${holidayID}`).set({
            bs2_id_hotel: hotelID ?? null,
            bs2_id_hotel_alternates: altIDs ?? null
        }, { merge:true })

        console.log("Done!")
    }

    return (
        <div style={{ width: "395px" }}>
            <Input
                label="bs2_id_hotel"
                showLabel={true}
                value={hotelID}
                onChange={setHotelID}
                placeholder=" "
                onBlur={() => saveHotelID()} />
            <br />
            <Input
                label="bs2_id_hotel_alternates"
                showLabel={true}
                value={altHotelIDs}
                onChange={setAltHotelIDs}
                placeholder=" "
                onBlur={() => saveHotelID()} />
            <br />
        </div>
    )
}
